<template>
  <v-carousel class="carousel" hide-delimiters>
    <v-carousel-item v-for="(product, i) in products" :key="i">
      <v-expansion-panels id="product-card" flat accordion>
        <v-expansion-panel>
          <v-expansion-panel-header @click="showCard">
            <v-img
              height="255px"
              width="408.18px"
              class="img"
              :src="product.img"
            ></v-img>
            <div class="left-panel">
              <div class="label">{{ product.label }}</div>
              <div class="title">{{ product.title }}</div>
              <div class="description">{{ product.description }}</div>
            </div>
            <v-divider vertical class="divider"></v-divider>
            <div class="right-panel">
              <div class="checkout">
                <v-icon color="#35887E">mdi-brightness-percent</v-icon>
                Kassenmodell
              </div>
              <div class="price">{{ product.price }}</div>
              <v-btn depressed text color="" class="coverage"
                >Kassenübernahme prüfen</v-btn
              >
              <div class="btns-wrap">
                <v-btn depressed block class="primary-txt-btn __h68"
                  >Auf die Merkliste setzen</v-btn
                >
                <v-btn depressed block class="grey-txt-btn __h68"
                  >Kein Interesse</v-btn
                >
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider class="divider-horizontal my-5"></v-divider>
            <div class="title">Header: Details zum Produkt</div>
            <div class="subtitle">Subtitle Lorem Ipsum</div>
            <div class="expanstion-content">
              <div class="left-panel">
                <v-carousel class="item-carousel" hide-delimiters>
                  <v-carousel-item v-for="(product, i) in products" :key="i">
                    <v-img
                      height="255px"
                      width="408.18px"
                      class="img"
                      :src="product.img"
                    >
                    </v-img>
                  </v-carousel-item>
                </v-carousel>
                <div class="coupon">
                  <div class="text-container">
                    <v-icon size="50px" color="black"
                      >mdi-brightness-percent</v-icon
                    >
                    Text 1
                  </div>
                  <div class="text-container">
                    <v-icon size="50px" color="black">mdi-compass</v-icon>
                    Text 1
                  </div>
                </div>
              </div>
              <div class="item-description">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                diam nonumy eirmod tempor invidunt ut labore et dolore magna
                aliquyam erat, sed diam voluptua. Lorem ipsum dolor sit amet
                consetetur sadipscing elitr sed diam nonumy eirmod tempor
                invidunt At vero eos et accusam et justo duo dolores et ea
                rebum. Stet clita kasd gubergren, no sea takimata sanctus est
                Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet. At vero
                eos et accusam et justo duo dolores et ea rebum. Stet clita kasd
                gubergren, no sea takimata sanctus est Lorem ipsum dolor sit
                amet. Lorem ipsum dolor sit amet,
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data: () => ({
    model: 0,
    products: [
      {
        img: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80",
        label: "Vorschlag 1 von 2",
        title: "Rollator Fakto+",
        description:
          "Der Rollator Fakto+ besteht aus einem pulverbeschichteten Stahlrohrrahmen mit integrierter Feststellbremse und ist höhenverstellbar.",
        price: " 99,00€",
      },
      {
        img: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80",
        label: "Vorschlag 1 von 2",
        title: "Rollator Fakto+",
        description:
          "Der Rollator Fakto+ besteht aus einem pulverbeschichteten Stahlrohrrahmen mit integrierter Feststellbremse und ist höhenverstellbar.",
        price: " 99,00€",
      },
      {
        img: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80",
        label: "Vorschlag 1 von 2",
        title: "Rollator Fakto+",
        description:
          "Der Rollator Fakto+ besteht aus einem pulverbeschichteten Stahlrohrrahmen mit integrierter Feststellbremse und ist höhenverstellbar.",
        price: " 99,00€",
      },
      {
        img: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80",
        label: "Vorschlag 1 von 2",
        title: "Rollator Fakto+",
        description:
          "Der Rollator Fakto+ besteht aus einem pulverbeschichteten Stahlrohrrahmen mit integrierter Feststellbremse und ist höhenverstellbar.",
        price: " 99,00€",
      },
    ],
  }),
  methods: {
    showCard() {
      setTimeout(() => {
        let cardPosition =
          window.scrollY - 20 +
          document.querySelector("#product-card").getBoundingClientRect().top;
        this.$vuetify.goTo(cardPosition);
      }, 400);
    },
  },
};
</script>

<style>
.v-window__next {
  right: 0;
}
</style>